import _asyncToGenerator from'@babel/runtime/helpers/asyncToGenerator';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _regeneratorRuntime from'@babel/runtime/regenerator';import React,{useState,useCallback,useEffect}from'react';import PropTypes from'prop-types';import dayjs from'dayjs';import throttle from'lodash/throttle';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';import MessageModal from'../MessageModal/MessageModal.js';import {SIGN_OUT_REASONS}from'../../utils/session.js';var TIMER_INTERVAL = 200;
var TimeoutComponent = function TimeoutComponent(props) {
  var maxIdleExpirationTime = props.maxIdleExpirationTime,
    maxSessionExpirationTime = props.maxSessionExpirationTime,
    sessionInfoFetched = props.sessionInfoFetched,
    extendSessionRateLimit = props.extendSessionRateLimit,
    onExtendSession = props.onExtendSession,
    onTimeout = props.onTimeout;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    logoutTimer = _useState2[0],
    setLogoutTimer = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showWarningModal = _useState4[0],
    setShowWarningModal = _useState4[1];
  var extendSession = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setShowWarningModal(false);
            onExtendSession();
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [setShowWarningModal, onExtendSession]);

  // Due to the way throttle works eslint isn't able to detect the dependencies automatically.
  // Disable the rule for this line as extendSession and extendSessionRateLimit are the only dependencies
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var throttledExtendSession = useCallback(throttle(extendSession, extendSessionRateLimit, {
    trailing: false
  }), [extendSession, extendSessionRateLimit]);
  var forceExtendSession = useCallback(function () {
    // We want to force an extend now but still respect the rate limit afterwards
    // Cancel to clear the pending limit and then invoke again
    throttledExtendSession.cancel();
    throttledExtendSession();
  }, [throttledExtendSession]);
  var handleMouseEvents = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!showWarningModal) {
              throttledExtendSession();
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [showWarningModal, throttledExtendSession]);
  var checkSession = useCallback(function () {
    var now = dayjs();
    var modalWarningTime = dayjs(maxIdleExpirationTime).subtract(1, 'minute');
    if (dayjs(maxSessionExpirationTime).isBefore(now)) {
      onTimeout(SIGN_OUT_REASONS.MAX_SESSION);
    } else if (dayjs(maxIdleExpirationTime).isBefore(now)) {
      onTimeout(SIGN_OUT_REASONS.INACTIVE);
    } else if (modalWarningTime.isBefore(now)) {
      setShowWarningModal(true);
      setLogoutTimer(dayjs(maxIdleExpirationTime).diff(dayjs(), 'seconds'));
    } else {
      setShowWarningModal(false);
    }
  }, [maxIdleExpirationTime, maxSessionExpirationTime, onTimeout]);
  useEffect(function () {
    var checkInterval;
    if (sessionInfoFetched && !maxIdleExpirationTime) {
      onTimeout(SIGN_OUT_REASONS.INACTIVE);
    } else if (sessionInfoFetched) {
      checkSession();
      checkInterval = setInterval(checkSession, TIMER_INTERVAL);
      window.addEventListener('click', handleMouseEvents);
      window.addEventListener('keydown', handleMouseEvents);
      window.addEventListener('mousedown', handleMouseEvents);
    } else {
      setShowWarningModal(false);
    }
    return function modalCleanup() {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
      window.removeEventListener('click', handleMouseEvents);
      window.removeEventListener('keydown', handleMouseEvents);
      window.removeEventListener('mousedown', handleMouseEvents);
    };
  }, [sessionInfoFetched, maxIdleExpirationTime, onTimeout, showWarningModal, handleMouseEvents, checkSession]);
  return /*#__PURE__*/React.createElement(MessageModal, {
    showModal: showWarningModal,
    buttonTitleId: "shared.session.keepMeSignedIn",
    onClickButton: forceExtendSession
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "shared.session.logoutWarningTimer",
    values: {
      count: logoutTimer
    }
  })));
};
process.env.NODE_ENV !== "production" ? TimeoutComponent.propTypes = {
  maxIdleExpirationTime: PropTypes.instanceOf(dayjs),
  maxSessionExpirationTime: PropTypes.instanceOf(dayjs),
  sessionInfoFetched: PropTypes.bool,
  onExtendSession: PropTypes.func.isRequired,
  extendSessionRateLimit: PropTypes.number,
  onTimeout: PropTypes.func.isRequired
} : void 0;
TimeoutComponent.defaultProps = {
  maxIdleExpirationTime: undefined,
  maxSessionExpirationTime: undefined,
  extendSessionRateLimit: 10000,
  sessionInfoFetched: false
};
var TimeoutComponent$1 = TimeoutComponent;export{TimeoutComponent$1 as default};